import {BaseModel} from '../../../shared/models';

export class ZonaExclusion extends BaseModel{
  zonaExclusionId: string;
  zonaExclusionGeometria: string;
}
